import { isBootFeatureEnabled } from 'owa-metatags';

export default function isOpxResourceTokenHandlingEnabled(): boolean {
    return !isBootFeatureEnabled('auth-opx-resourceTokenHandlingRipcord');
}
